import { Link } from "react-router-dom"
import { PageHeader } from "@/components/page"
import { useAuthStore } from "../stores/authStore"

export default function NotFoundPage() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  return (
    <div className="section-shell flex min-h-[50vh] flex-col items-start justify-center gap-4 py-16">
      <PageHeader title="Esta página no existe" />
      <p className="max-w-md text-sm text-muted-foreground">
        El enlace puede estar incompleto o la página se movió. Vuelve al inicio y retoma desde ahí.
      </p>
      <Link
        to={isAuthenticated ? "/dashboard" : "/courses"}
        className="inline-flex min-h-11 items-center rounded-lg bg-primary px-4 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50 sm:min-h-9"
      >
        {isAuthenticated ? "Ir a mi inicio" : "Ver cursos"}
      </Link>
    </div>
  )
}
